<template>
  <page-content
    v-if="checkup"
    title="Konsultasi Psikologi: Detail Riwayat"
    :with-margin="false"
    back-button
  >
    <br />
    <!-- Survey alert -->
    <survey-alert class="mx-3 mb-1" />
    <simple-list
      label="Hal yang akan dikonsultasikan"
      :text="checkup.problem"
    />
    <simple-list
      label="Jadwal Konsultasi"
      :text="
        getScheduleOptionText(
          checkup.schedule.day,
          checkup.schedule.time_start,
          checkup.schedule.time_end
        )
      "
    />
    <simple-list label="Status">
      <div class="mt-1 d-flex align-items-center flex-wrap">
        <span class="badge mr-1 mb-1" :class="getCheckupBadge(checkup.status)">
          {{ capitalize(getCheckupStatusIndo(checkup.status)) }}
        </span>
        <template v-if="['scheduled', 'completed'].includes(checkup.status)">
          <span
            class="badge flex-shrink-0 d-inline-flex align-items-center mr-1 mb-1 text-gray"
          >
            <material-icon name="event" type="rounded" size="12" class="mr-1" />
            {{ formatDateForHuman(checkup.scheduled_at, true) }}
          </span>
          <span
            class="badge flex-shrink-0 d-inline-flex align-items-center mr-1 mb-1 text-gray"
          >
            <material-icon
              name="schedule"
              type="rounded"
              size="12"
              class="mr-1"
            />
            {{ formatTimeToIndo(checkup.schedule.time_start) }} -
            {{ formatTimeToIndo(checkup.schedule.time_end) }} WIB
          </span>
          <span
            class="badge flex-shrink-0 d-inline-flex align-items-center mb-1 text-gray"
          >
            <material-icon
              name="chair"
              type="outlined"
              size="12"
              class="mr-1"
            />
            {{ checkup.room.name }}
          </span>
        </template>
      </div>
      <small
        v-if="checkup.status == 'unscheduled'"
        class="d-flex align-items-start mt-2"
      >
        Harap menunggu, petugas akan mengatur jadwal dan menghubungi saudara.
      </small>
    </simple-list>
    <!-- Screening -->
    <div class="m-3">
      <h4 class="mb-1">Skrining</h4>
      <div class="card px-0">
        <simple-list
          v-for="(screening, index) in checkup.screenings"
          :key="index"
          :label="screening.question"
          :text="screening.answer"
        />
      </div>
    </div>
    <!-- Solution -->
    <div v-if="checkup.status == 'completed'" class="mt-3 mx-3">
      <h4 class="d-flex align-items-center">
        Solusi/rekomendasi dari psikolog
      </h4>
      <div class="card card-success text-white mt-1">
        <div class="unreset">
          <div v-html="checkup.suggestion"></div>
        </div>
        <div class="divider" style="background: rgba(255, 255, 255, 0.4)"></div>
        <div class="d-flex gap-1">
          <span
            v-if="checkup.is_reffered == '1'"
            class="d-inline-flex align-items-center badge badge-warning"
          >
            <material-icon name="gpp_good" size="16" class="mr-1" />
            Dirujuk
          </span>
          <span class="d-inline-flex align-items-center badge badge-primary">
            <material-icon name="assignment_ind" size="16" class="mr-1" />
            <span class="mr-1">Psikolog:</span>
            <b>{{ checkup.psychologist }}</b>
          </span>
        </div>
      </div>
    </div>
  </page-content>
</template>

<script>
import axios from "axios";
import {
  getScheduleOptionText,
  getCheckupStatus,
  getCheckupStatusIndo,
  getCheckupBadge,
} from "@/helpers/mental-health";
import SurveyAlert from "@/components/SurveyAlert.vue";

export default {
  name: "mental-health-history-detail",
  components: {
    SurveyAlert,
  },
  data: function () {
    return {
      id: 0,
      checkup: null,
    };
  },
  methods: {
    getScheduleOptionText,
    getCheckupStatus,
    getCheckupStatusIndo,
    getCheckupBadge,
    getHistory: function () {
      this.startPageLoading();
      axios
        .get(this.apiBaseUrl + "mental-health/checkups/own/" + this.id)
        .then((response) => {
          this.stopPageLoading();
          this.checkup = response.data.data;
          this.checkup.status = this.getCheckupStatus(this.checkup);
        })
        .catch(() => {
          this.$toasted.error("Data tidak ditemukan.");
        });
    },
  },
  created: function () {
    this.id = this.$route.params.id;
    this.getHistory();
  },
};
</script>
